export const stepsWelcomeInicial = [
  {
    target: '.stepNavegacao',
    content: `Todas as telas do sistema podem ser encontradas no menu.`,
    disableBeacon: true,
    spotlightPadding: 3,
  },
  {
    target: '.stepFavoritos',
    content: `Com essa função você consegue definir telas como favoritas.
              <br/><br/>
             O sistema exibirá o ícone referente à tela no cabeçalho, para que o acesso seja feito rapidamente.`,
    spotlightPadding: 1,
  },
  {
    target: '.stepHome',
    content: `Clicando aqui você retorna à Visão geral, tela inicial do sistema.`,
    spotlightPadding: -3,
  },
  {
    target: '.stepPerfil',
    content: `Seu nome será exibido no topo do cabeçalho.
             <br/><br/>
             Ao clicar sobre ele, o sistema exibirá as opções para visualizar as informações do seu perfil, informações da empresa e a opção para sair do sistema.`,
    spotlightPadding: -5,
  },
  {
    target: '.stepPesquisa',
    content: `Neste ícone você consegue fazer buscas por qualquer tela no sistema.`,
    spotlightPadding: -5,
  },
  {
    target: '.stepAjuda',
    content: `Esta é a central de ajuda.
             <br/><br/>
             Ela possui vários artigos explicativos para te ajudar. Grande parte das dúvidas são solucionadas nesta funcionalidade.`,
    spotlightPadding: -5,
  },
];
